import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchQuizzes,
  fetchLiveQuizParticipants,
} from "../Quiz/redux/quizSlice";
import AllFeatureDataTable from "../../GuiComponents/AllFeatureDataTable.table";
import { Skeleton } from "@mui/material";
import { apiKeyHeader } from "../../configs/ApiKeys";
import axios from "axios";

const LiveQuizzes = () => {
  const dispatch = useDispatch();
  const { quizzes, liveParticipants, loading, error } = useSelector(
    (state) => state.quiz
  );

  const [selectedQuiz, setSelectedQuiz] = useState("");
  const [popupData, setPopupData] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [popupLoading, setPopupLoading] = useState(false);

  useEffect(() => {
    dispatch(fetchQuizzes({ type: "1" }));
    setSelectedQuiz("");
  }, [dispatch]);

  const handleQuizChange = (e) => {
    const quizId = e.target.value;
    setSelectedQuiz(quizId);
    if (quizId) {
      dispatch(fetchLiveQuizParticipants({ quiz_id: quizId }));
    }
  };
  const openPopup = async (participant) => {
    try {
      setPopupLoading(true);
      setShowPopup(true);

      const res = await axios.get(
        `https://web1024.docmaster.in:5010/school/results?user_id=${participant.user_id}&quiz_id=${selectedQuiz}`,
        {
          headers: apiKeyHeader(),
        }
      );

      setPopupData(res.data);
    } catch (err) {
      console.error("Error fetching result details:", err);
      setPopupData({ error: "Failed to load result details." });
    } finally {
      setPopupLoading(false);
    }
  };

  const columns = [
    { Header: "#", accessor: "sno" },
    { Header: "Username", accessor: "username" },
    { Header: "Email", accessor: "email" },
    { Header: "Score", accessor: "score" },
    { Header: "Status", accessor: "participation_status" },
    { Header: "Registered At", accessor: "registered_at" },
    { Header: "Completed At", accessor: "completed_at" },
    {
      Header: "Action",
      accessor: "action",
      Cell: ({ row }) => (
        <img
          width="20"
          height="20"
          src="https://img.icons8.com/ios-glyphs/30/visible--v1.png"
          alt="view"
          style={{ cursor: "pointer" }}
          onClick={() => openPopup(row.original)}
        />
      ),
    },
  ];

  const data = (liveParticipants || []).map((p, index) => ({
    ...p,
    sno: index + 1,
    started_at: p.started_at ? new Date(p.started_at).toLocaleString() : "-",
    completed_at: p.completed_at
      ? new Date(p.completed_at).toLocaleString()
      : "-",
    registered_at: p.registered_at
      ? new Date(p.registered_at).toLocaleString()
      : "-",
    participation_status: p.participation_status || "registered",
  }));
  const closePopup = () => {
    setShowPopup(false);
    setPopupData(null);
  };

  return (
    <div>
      {loading && <Skeleton count={5} height={30} className="mb-2" />}
      {error && <p className="text-danger">Error: {error}</p>}

      {!loading && quizzes?.length > 0 && (
        <select
          className="form-select w-50 mb-3 py-1"
          value={selectedQuiz}
          onChange={handleQuizChange}
          style={{ fontSize: "0.9rem" }}
        >
          <option value="">Select Quiz</option>
          {quizzes.map((quiz) => (
            <option key={quiz.id} value={quiz.id}>
              {quiz.title}
            </option>
          ))}
        </select>
      )}

      {selectedQuiz && (
        <div>
          {loading && (
            <div style={{ width: "100%" }}>
              {[...Array(25)].map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rectangular"
                  height={15}
                  className="mb-1"
                />
              ))}
            </div>
          )}
          {!loading && data.length > 0 ? (
            <AllFeatureDataTable columns={columns} data={data} />
          ) : (
            !loading && <p>No participants found for this quiz.</p>
          )}
        </div>
      )}
      {showPopup && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 999,
          }}
          onClick={closePopup}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              maxWidth: "900px",
              width: "95%",
              position: "relative",
              height: "80vh",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              style={{
                position: "absolute",
                top: "10px",
                right: "15px",
                fontSize: "20px",
                fontWeight: "bold",
                color: "#555",
                background: "none",
                border: "none",
                cursor: "pointer",
              }}
              onClick={closePopup}
            >
              &times;
            </button>

            {popupLoading ? (
              <p>Loading result details...</p>
            ) : popupData?.error ? (
              <p style={{ color: "red" }}>{popupData.error}</p>
            ) : popupData ? (
              <>
                <h4 style={{ textAlign: "center", marginBottom: "15px" }}>
                  {popupData?.quiz?.quiz_name} ({popupData?.quiz?.quiz_type})
                </h4>

                <h5>Result Info</h5>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Total Questions</th>
                      <th>Attempted</th>
                      <th>Correct</th>
                      <th>Wrong</th>
                      <th>Total Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{popupData?.stats?.total_questions || "-"}</td>
                      <td>{popupData?.stats?.attempted || "-"}</td>
                      <td>{popupData?.stats?.correct || "-"}</td>
                      <td>{popupData?.stats?.wrong || "-"}</td>
                      <td>{popupData?.stats?.total_score || "-"}</td>
                    </tr>
                  </tbody>
                </table>

                <h5 style={{ marginTop: "20px" }}>Question Info</h5>
                <div style={{ height: "40vh", overflowY: "auto" }}>
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Question</th>
                        <th>Correct Option</th>
                        <th>Selected Option</th>
                        <th>Time Taken</th>
                        <th>Score</th>
                      </tr>
                    </thead>
                    <tbody>
                      {popupData?.answers?.map((q, idx) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td>{q.question}</td>
                          <td>{q.correct_option}</td>
                          <td>
                            {q.selected_option ? (
                              <span
                                style={{
                                  color:
                                    q.selected_option === q.correct_option
                                      ? "green"
                                      : "red",
                                }}
                              >
                                {q.selected_option}
                              </span>
                            ) : (
                              <span style={{ color: "orange" }}>
                                Not attempted
                              </span>
                            )}
                          </td>
                          <td>
                            {q.time_taken_ms
                              ? `${(q.time_taken_ms / 1000).toFixed(2)} sec`
                              : "N/A"}
                          </td>
                          <td>{q.score}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </>
            ) : (
              <p>No data found.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default LiveQuizzes;
